<template>
  <component
    :is="tag"
    :type="tag === 'button' ? 'button' : undefined"
    v-bind="attrs"
    class="m-dropdown__link"
    :class="{
      'm-dropdown__link--active': active,
      [`m-dropdown__link--${size}`]: size !== 'default',
    }"
    @click.native="$emit('click')"
  >
    <slot />
  </component>
</template>

<script>
import { clickableTag } from '../../../lib/type-validators'
import { getLinkAttrs } from '../../../lib/utils'
export default {
  name: 'MDropdownLink',
  inheritAttrs: false,
  props: {
    /**
     * Set the link to active. e.g. If we are on this page already.
     */
    active: {
      type: Boolean,
      default: false,
    },
    /**
     * HTML tag to render
     */
    tag: {
      type: [Object, String],
      default: 'a',
      validator: clickableTag,
    },
    /**
     * Set the size of the dopdown link
     */
    size: {
      type: String,
      default: 'default',
      validator: (prop) => ['default', 'small', 'large'].includes(prop),
    },
  },
  emits: ['click'],
  computed: {
    attrs() {
      return getLinkAttrs(this.$attrs, this.tag)
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../sass/framework/mixins/clickable';
@use '../../../sass/framework/mixins/font-size';

.m-dropdown__link {
  @include clickable.clickable;
  @include font-size.font-size(sm);
  appearance: none;
  background: none;
  border: 0 none;
  color: var(--color-text-body-dark);
  display: block;
  margin: 0;
  padding: var(--spacing-12) var(--spacing-16);
  text-align: left;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;

  &--small {
    padding: var(--spacing-8) var(--spacing-12);
  }

  &--large {
    @include font-size.font-size(base);
    padding: var(--spacing-16) var(--spacing-24);
  }

  &--active {
    &::after {
      background-color: var(--color-primary-regular);
      bottom: 0;
      content: '';
      height: 100%;
      left: 0;
      position: absolute;
      width: 6px;
    }
  }
}
</style>
